import { Link } from 'react-router-dom'
import './home.css'

const Home = () => {
  return (
    <main className="demografica-home">

      {/* HERO */}
      <section className="home-hero">
        <div className="home-hero__content">
          <p className="home-eyebrow">
            DATOS · TERRITORIO · POLÍTICAS PÚBLICAS
          </p>

          <h1>
            Convertimos datos sociales en
            <span> conocimiento territorial.</span>
          </h1>

          <p className="home-hero__description">
            Análisis en demografía, desigualdad, pobreza, salud,
            movilidad y territorio para comprender mejor la realidad
            social de Chile y apoyar la toma de decisiones.
          </p>

          <div className="home-hero__actions">
            <Link to="/censo" className="home-btn home-btn--primary">
              Explorar Censo 2024 →
            </Link>

            <Link to="/plans" className="home-btn home-btn--secondary">
              Conocer nuestros servicios
            </Link>
          </div>
        </div>

        <div className="home-hero__visual">
          <div className="hero-map-placeholder">
            <span>ANÁLISIS TERRITORIAL</span>
            <strong>Santiago</strong>
            <small>
              Indicadores sociales a escala territorial
            </small>
          </div>
        </div>
      </section>


      {/* ÁREAS PRINCIPALES */}
      <section className="home-expertise">
        <article className="expertise-card">
          <span className="expertise-icon">01</span>
          <h3>Demografía y territorio</h3>
          <p>
            Población, envejecimiento, migraciones y estructura
            territorial.
          </p>
        </article>

        <article className="expertise-card">
          <span className="expertise-icon">02</span>
          <h3>Desigualdad y pobreza</h3>
          <p>
            Análisis de ingresos, educación, salud y condiciones
            de vida con enfoque territorial.
          </p>
        </article>

        <article className="expertise-card">
          <span className="expertise-icon">03</span>
          <h3>Análisis espacial y SIG</h3>
          <p>
            Mapas, indicadores y focalización territorial con
            R y datos oficiales.
          </p>
        </article>

        <article className="expertise-card">
          <span className="expertise-icon">04</span>
          <h3>Consultoría y docencia</h3>
          <p>
            Análisis aplicado, visualizaciones interactivas
            y formación especializada en R.
          </p>
        </article>
      </section>


      {/* CENSO 2024 */}
      <section className="home-censo">
        <div className="home-censo__content">
          <p className="home-eyebrow">
            PLATAFORMA DESTACADA
          </p>

          <h2>Censo 2024</h2>
          <h3>Índice de privación territorial</h3>

          <p>
            Una plataforma interactiva para explorar la privación
            territorial en Chile y analizar desigualdades a escala
            comunal y subcomunal.
          </p>

          <ul>
            <li>Índice de Privación Multidimensional (IPMS)</li>
            <li>Mapas y visualizaciones interactivas</li>
            <li>Comparación comunal y nacional</li>
            <li>Identificación de focos críticos</li>
            <li>Escenarios de intervención</li>
          </ul>

          <Link to="/censo" className="home-btn home-btn--primary">
            Ir a Censo 2024 →
          </Link>
        </div>

        <div className="home-censo__visual">
          <div className="censo-preview">
            <span>DEMOGRÁFICA · CENSO 2024</span>
            <strong>Inteligencia territorial</strong>
            <p>
              Privación · desigualdad · focalización
            </p>
          </div>
        </div>
      </section>


      {/* MÉTODOS */}
      <section className="home-methods">
        <div className="home-methods__intro">
          <p className="home-eyebrow">MÉTODOS Y DATOS</p>

          <h2>
            Rigor estadístico para problemas reales.
          </h2>
        </div>

        <div className="methods-grid">
          <article>
            <strong>R y tidyverse</strong>
            <span>Análisis estadístico</span>
          </article>

          <article>
            <strong>Censo y CASEN</strong>
            <span>Bases de datos oficiales</span>
          </article>

          <article>
            <strong>SIG y visualización</strong>
            <span>Mapas y territorio</span>
          </article>

          <article>
            <strong>Modelos y escenarios</strong>
            <span>Análisis aplicado</span>
          </article>
        </div>
      </section>


      {/* IDENTIDAD */}
      <section className="home-mission">
        <div className="home-mission__content">
          <p className="home-eyebrow">
            EVIDENCIA PARA CHILE
          </p>

          <h2>
            Comprender el territorio para una sociedad más justa.
          </h2>

          <p>
            Ponemos la evidencia demográfica, social y territorial
            al servicio de mejores decisiones públicas y privadas.
          </p>
        </div>
      </section>


      {/* ÁREAS TEMÁTICAS */}
      <section className="home-topics">
        <p className="home-eyebrow">ÁREAS TEMÁTICAS</p>

        <div className="topics-grid">
          <span>Envejecimiento</span>
          <span>Pobreza</span>
          <span>Salud pública</span>
          <span>Movilidad territorial</span>
          <span>Educación</span>
          <span>Vivienda y segregación</span>
          <span>Desigualdad territorial</span>
          <span>Migraciones</span>
        </div>
      </section>


      {/* CONTACTO */}
      <section className="home-contact">
        <div>
          <p className="home-eyebrow">
            TRABAJEMOS JUNTOS
          </p>

          <h2>¿Necesitas un análisis para tu proyecto?</h2>

          <p>
            Desarrollamos soluciones basadas en datos para
            instituciones, organizaciones e investigación.
          </p>
        </div>

        <Link to="/contact" className="home-btn home-btn--light">
          Contactar →
        </Link>
      </section>

    </main>
  )
}

export default Home